import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'
import { Box } from '@mui/material'
import { IconCell } from 'components/core-ui/IconCell'
import { DefectReason, ProductType, statusColorMapping } from "components/shop-reception/enums";
import { Link } from 'react-router-dom'
import { formatUIDate } from 'utils/helpers'

export const columns = [
  {
    title: 'Numar comanda (INFOLOG)',
    field: 'externalOrderId',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Numar comanda origine',
    field: 'originalOrderId',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Cod suport',
    field: 'supportCode',
    align: 'left',
    type: 'string',
    width: '120px',
    render: row => (
      <Link to={`/shop-reception/reception/deliverySupportAction/${row.supportCode}`}>
        {row.supportCode}
      </Link>
    )
  },
  {
    title: 'Eticheta suport',
    field: 'heterogeneousCode',
    align: 'left',
    type: 'string',
    width: '150px',
    disableSorting: true
  },
  {
    title: 'Tip suport asteptat',
    field: 'expectedSupportType',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Tip ambalaj secundar asteptat',
    field: 'secondarySupportType',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Status receptie suport',
    field: 'supportStatusValue',
    align: 'left',
    type: 'string',
    width: '120px',
    render: row => (
      <div style={{ color: statusColorMapping[row.supportStatus] || 'black' }}>{row.supportStatusValue}</div>
    ),
    disableSorting: true
  },
  {
    title: 'Cod EAN',
    field: 'eanCode',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'EAN receptionat',
    field: 'eanReceived',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Cod produs',
    field: 'productCode',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Nume produs',
    field: 'productName',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Prioritar vanzare',
    field: 'priorityForSale',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true,
    render: row => (
      <Box>
        <IconCell value={row.priorityForSale ? 'activ' : 'inactiv'} />
      </Box>
    )
  },
  {
    title: 'Unitate de masura',
    field: 'measureUnit',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '120px'
  },
  {
    title: 'Cantitate asteptata pe suport',
    field: 'deliveredQuantity',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Cantitate asteptata in comanda',
    field: 'totalDeliveredQuantity',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Cantitate receptionata calitativa',
    field: 'qualitativeQuantity',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Cantitate receptionata deteriorata',
    field: 'defectQuantity',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Diferenta',
    field: 'missingQuantity',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Motiv defectiune',
    field: 'defectReason',
    align: 'left',
    type: 'string',
    width: '120px',
    render: row => DefectReason[row.defectReason],
    disableSorting: true
  },
  {
    title: 'Tip scanare recomandat',
    field: 'recommendedScanType',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Tip scanare suport',
    field: 'scanType',
    align: 'left',
    type: 'string',
    width: '120px',
    render: row => ProductType[row.scanType],
    disableSorting: true
  },
  {
    title: 'Numar colete asteptate',
    field: 'secondarySupportNumber',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Produs cu DLC scurt',
    field: 'shortDlc',
    align: 'left',
    type: 'string',
    width: '120px',
    render: row => (
      <Box>
        <IconCell value={row.shortDlc ? 'activ' : 'inactiv'} />
      </Box>
    ),
    disableSorting: true
  },
  {
    title: 'Data limita de consum asteptata',
    field: 'dlcDate',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Data limita de consum receptionata',
    field: 'confirmedDlc',
    align: 'left',
    type: 'string',
    width: '120px',
    render: row => formatUIDate(row.dlcDateExcel),
    disableSorting: true
  },
  {
    title: 'Lot',
    field: 'batch',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Produs sensibil',
    field: 'sensitive',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true,
    render: row => (
      <Box>
        <IconCell value={row.sensitive ? 'activ' : 'inactiv'} />
      </Box>
    )
  },
  {
    title: 'Produs verificat',
    field: 'verified',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true,
    render: row => (
      <Box>
        <IconCell value={row.verified ? 'activ' : 'inactiv'} />
      </Box>
    )
  },
  {
    title: 'Produs lipsa',
    field: 'missing',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true,
    render: row => (
      <Box>
        <IconCell value={row.missing ? 'activ' : 'inactiv'} />
      </Box>
    )
  },
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Data receptie',
    field: 'receptionDate',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Procent valabilitate',
    field: 'lifetimePercentage',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true
  },
  {
    title: 'Produs cu SGR',
    field: 'sgr',
    align: 'left',
    type: 'string',
    width: '120px',
    disableSorting: true,
    render: row => (
      <Box>
        <IconCell value={row.sgr ? 'activ' : 'inactiv'} />
      </Box>
    )
  }
]

export const drawerFilters = (supportCodeOptions, productCodeOptions) => [
  {
    name: 'supportCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează cod suport"
        disableClearable
        options={supportCodeOptions}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează cod suport'
  },
  {
    name: 'productCode',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza produs"
        disableClearable
        options={
          productCodeOptions.map(item => ({
            label: item.name,
            value: item.code
          }))
        }
      />
    ),
    type: 'autocomplete',
    label: 'Selecteaza produs'
  }
]
